<app-button (click)="loginRedirect()" *ngIf="!user" type="positive" [disabled]="isProcessing" [title]="'Login'">
    <label *ngIf="!isProcessing">Login</label>
    <fa-icon [icon]="['far', 'spinner-third']" [animation]="'spin'" *ngIf="isProcessing"></fa-icon>
</app-button>
<ng-container *ngIf="user">
    <label>{{ user.name }}</label>
    <app-button (click)="logout()" type="negative" [title]="'Logout'">Logout</app-button>
</ng-container>
